import { runStopAudio } from './stop-playback-implementation';

export function runStopAudioImplementation(data: {
  target?: { id?: string };
}) {
  const targetId = data?.target?.id;
  if (!targetId) return;
  runStopAudio({ allTargets: false, targetId });
}

export function runStopAllAudioImplementation() {
  runStopAudio({ allTargets: true });
}
